import styled from "styled-components";
import smartphoneIcon from "assets/icons/smartphoneIcon.svg";
import appStoreIcon from "assets/icons/app_store.svg";
import playStoreIcon from "assets/icons/play_store.svg";

const AdsMobileAppWrapper = styled.a`
  display: flex;
  padding: 24px;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05),
    0px 25px 35px 0px rgba(0, 0, 0, 0.03);
  gap: 24px;
  margin-top: 24px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1),
      0px 25px 35px 0px rgba(188, 169, 169, 0.1);
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
    width: 100%;
  }

  .leftContent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    flex: 1;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      width: 100%;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }

    .iconWrapper {
      flex-shrink: 0;
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(
        135deg,
        var(--primary) 0%,
        var(--primary_light) 100%
      );
      border-radius: 12px;
      padding: 12px;

      img {
        width: 100%;
        height: 100%;
        filter: brightness(0) invert(1);
      }
    }

    .textContent {
      display: flex;
      flex-direction: column;
      gap: 8px;
      flex: 1;
      min-width: 250px;

      .heading {
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
        color: var(--grey_1);
      }

      .description {
        font-size: 14px;
        line-height: 20px;
        color: var(--grey_8);
      }
    }

    .storeBadges {
      display: flex;
      gap: 12px;
      align-items: center;
      flex-shrink: 0;

      @media (max-width: 768px) {
        width: 100%;
      }

      .badgeWrapper {
        background-color: #000;
        padding: 6px 12px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

        &:hover {
          background-color: #1a1a1a;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
          transform: translateY(-1px);
        }

        img {
          height: 32px;
          width: auto;
          transition: transform 0.2s ease;

          &:hover {
            transform: scale(1.05);
          }
        }
      }
    }
  }

  .rightContent {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    @media (max-width: 768px) {
      display: none;
    }

    .illustrationIcon {
      width: 80px;
      height: 80px;
      opacity: 0.6;
    }
  }
`;

const AdsMobileAppDownload = () => {
  return (
    <AdsMobileAppWrapper
      href="https://qr-codes.io/qlj83W"
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="leftContent">
        {/* <div className="iconWrapper">
          <img src={smartphoneIcon} alt="mobile" />
        </div> */}
        <div className="textContent">
          <p className="heading">AI Ads Manager</p>
          {/* <p className="description">
            Download our AI Ads manager mobile app to setup your ad campaigns in
            minutes.
          </p> */}
          <p className="description">
            Launch Google and Snapchat campaigns in minutes.
          </p>
        </div>
        <div className="storeBadges">
          <div className="badgeWrapper">
            <img src={appStoreIcon} alt="Download on App Store" />
          </div>
          <div className="badgeWrapper">
            <img src={playStoreIcon} alt="Get it on Google Play" />
          </div>
        </div>
      </div>
      {/* <div className="rightContent">
        <img
          src={smartphoneIcon}
          alt="mobile illustration"
          className="illustrationIcon"
        />
      </div> */}
    </AdsMobileAppWrapper>
  );
};

export default AdsMobileAppDownload;
